export { default as Funnel } from './Funnel';
